import type { ActionTree } from 'vuex';
import { getPrefetchData as neoGetPrefetchData } from '@mx/neo';
import type {
  CashierState,
  DeferRootState,
  DefaultPayloadType,
  GetPaydelayDisplayConsultPayLoad,
  DisplayConsultPayLoad,
} from '../constants';
import { paydelayDisplayConsult, env, monitor, metricPoints, NSFUrl } from '@/common';

interface PrefetchDataType {
  status: string;
  data: DisplayConsultDataType;
}
export const actions: ActionTree<CashierState, DeferRootState> = {
  getPaydelayDisplayConsultDataHandle({ state, getters, commit, dispatch }, payload: DefaultPayloadType) {
    return dispatch<GetPaydelayDisplayConsultPayLoad>({
      type: 'getPaydelayDisplayConsultData',
      requestChannel: payload.requestChannel,
    })
      .then((result) => {
        let NSFIsUse = 0; // 0 表示未使用 NSF 给的请求参数，1 表示使用 NSF 给的请求参数
        // 成功处理
        if (result.status && result.data) {
          NSFIsUse = 1;
          // eslint-disable-next-line no-param-reassign
          result = result.data;
        }
        monitor.reportMetric(metricPoints.NSFIsUse, { url: NSFUrl.Paydelay, NSFIsUse });
        commit({ type: 'setDisplayConsultData', displayConsultData: result });
        if (state.displayConsultData.routeStatus !== 0) {
          // 降级到标准收银台
          throw new Error('routeStatus === 1，异常情况降级标准收银台');
        }
      })
      .catch((err: Error) => {
        throw err;
      });
  },
  // 获取 paydelayDisplayConsult 数据，取预请求中的数据，失败时用ajax重新请求一次
  getPaydelayDisplayConsultData(
    { state, getters, commit, dispatch },
    payload: DefaultPayloadType
  ): Promise<DisplayConsultDataType & { __requestTime: string }> {
    let dispatcherData = null;
    const requestStartTime = Date.now();
    let enableNSF = 0; // 0 表示不能使用 NSF，1 表示能使用 NSF
    if (env.enableNsf) {
      enableNSF = 1;
      dispatcherData = neoGetPrefetchData<PrefetchDataType>(NSFUrl.Paydelay, {
        ajaxFunc: () => dispatch<DisplayConsultPayLoad>({ type: 'getPaydelayDisplayConsultDataByAjax' }),
        ajaxDelay: 2500, // 延迟请求时间 单位ms
        timeout: 5000, // 预请求桥超时时间，单位毫秒和降级时间对齐
      });
    } else {
      dispatcherData = dispatch<DisplayConsultPayLoad>({ type: 'getPaydelayDisplayConsultDataByAjax' });
    }
    monitor.reportMetric(metricPoints.enableNSF, { url: NSFUrl.Paydelay, enableNSF });
    return dispatcherData
      .then((resp) => {
        return {
          ...resp, // 返回接口数据
          __requestTime: Date.now() - requestStartTime,
        };
      })
      .catch((e: Error) => {
        Object.assign(e, { __requestTime: Date.now() - requestStartTime });
        throw e;
      });
  },

  getPaydelayDisplayConsultDataByAjax({ state, getters, commit, dispatch }, payload) {
    return paydelayDisplayConsult({
      ...env.inpayBasicBusinessParams,
      ...env.coreBusinessParams,
      outer_business_data: env.outerBusinessData,
    });
  },
};
